/**
 * Detects if the current device is iOS
 */
export function isIOS(): boolean {
  if (typeof window === "undefined" || !navigator) {
    return false;
  }
  const userAgent = navigator.userAgent || navigator.vendor;
  // @ts-expect-error - MSStream is a legacy IE property
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

/**
 * Detects if the current device is Android
 */
export function isAndroid(): boolean {
  if (typeof window === "undefined" || !navigator) {
    return false;
  }
  const userAgent = navigator.userAgent || navigator.vendor;
  return /android/i.test(userAgent);
}

/**
 * Detects if the current device is mobile (iOS or Android)
 */
export function isMobile(): boolean {
  return isIOS() || isAndroid();
}
